import { useScript } from '@libs/ui/ds'
import type { FC } from 'react'

import type { ScriptProps } from './Script.types'

export const Script: FC<ScriptProps> = props => {
  useScript(props)

  return null
}
